import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { Chip } from '@material-ui/core'

import { components } from '@plandi/common/src/generated'
import { useProfileDetailsStyles } from './profile-details.styles'
import { Translations } from './profile-details.constants'

type ProfileEmploymentProps = {
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
}

export const ProfileEmployment: FC<ProfileEmploymentProps> = ({
  profileFreelancer
}) => {
  const { EMPLOYMENT_TYPE } = Translations()
  const classes = useProfileDetailsStyles()

  const renderEmployment = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          Занятость
        </Typography>
        <div className={classes.groupChip}>
          {profileFreelancer?.condition?.employments?.map((employment) => (
            <Chip key={employment} label={EMPLOYMENT_TYPE[employment]} />
          ))}
          {profileFreelancer?.condition?.remoteWork && (
            <Chip label="Удаленная работа" />
          )}
        </div>
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderEmployment()}</CardContent>
    </Card>
  )
}
